var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.chartMap[_vm.chartVisualizeType].component,_vm._b({ref:"chartWrappers",tag:"components",staticStyle:{"height":"100%"},on:{"onLegendClick":_vm.onLegendClick}},'components',_vm.chartMap[_vm.chartVisualizeType].props,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a01e8f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/CDNChart.vue
// module id = null
// module chunks = 